import React from "react";
import { Link } from "react-router-dom";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";
import { daysUntil } from "@/lib/plan";

/**
 * Compact one-line banner shown on the dashboard.
 * - During trial: "X days left in your free trial → Upgrade"
 * - Free: "X / Y AI photos used today → Upgrade for unlimited"
 * - Advanced (paid): nothing (panel rendered elsewhere)
 */
export default function PlanBanner({ usage }) {
  if (!usage) return null;
  const { plan, photos_today, photos_daily_limit } = usage;

  if (plan.tier === "advanced" && !plan.in_trial) {
    return null;
  }

  if (plan.tier === "advanced" && plan.in_trial) {
    const left = daysUntil(plan.trial_ends_at);
    return (
      <Link
        to="/profile?focus=upgrade"
        className="block card-organic p-4 mt-4 hover:bg-[#F0EFE9] transition-colors"
        data-testid="plan-banner-trial"
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <span className="w-9 h-9 rounded-full bg-[#2B422F] flex items-center justify-center shrink-0">
              <Sparkle size={16} weight="fill" className="text-[#E6D4C4]" />
            </span>
            <div className="min-w-0">
              <div className="text-sm font-medium text-[#1A2421] truncate">
                {left} day{left === 1 ? "" : "s"} left in your free trial
              </div>
              <div className="text-xs text-[#5C6B62] mt-0.5">Lock in Advanced for $6.99/mo</div>
            </div>
          </div>
          <ArrowRight size={16} className="text-[#5C6B62] shrink-0" />
        </div>
      </Link>
    );
  }

  // Free tier
  const used = photos_today || 0;
  const remaining = Math.max(0, photos_daily_limit - used);
  return (
    <Link
      to="/profile?focus=upgrade"
      className="block card-organic p-4 mt-4 hover:bg-[#F0EFE9] transition-colors"
      data-testid="plan-banner-free"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <span className="w-9 h-9 rounded-full bg-[#C76E4B] flex items-center justify-center shrink-0">
            <Sparkle size={16} weight="fill" className="text-white" />
          </span>
          <div className="min-w-0">
            <div className="text-sm font-medium text-[#1A2421] truncate">
              {remaining} of {photos_daily_limit} AI photos left today
            </div>
            <div className="text-xs text-[#5C6B62] mt-0.5">Go unlimited · $6.99/mo</div>
          </div>
        </div>
        <ArrowRight size={16} className="text-[#5C6B62] shrink-0" />
      </div>
    </Link>
  );
}
